// 메신저(MM) iframe 에 주입하는 '글 편집' 버튼 CSS — 모바일 인라인 편집의 저장·취소 버튼 글자가
// 세로로 줄바꿈되는 증상을 막는다(req-20260929-094528-becaa3).
// 왜 CSS 주입인가: .post-edit__container 는 MM 웹앱 마크업이라(레포 'post-edit' grep 0건) 우리가
//    고칠 수 없고, 같은 오리진 iframe 이라 통제 지점은 그 문서의 style 요소뿐이다(mmModalCss 선례).
// 🔴 전 규칙을 @media (max-width:768px) 안에 둔다 — 데스크톱 회귀 0(mmPostEditCss.test.js 가 단언).
//    모바일은 MobileScale zoom 으로 iframe 내부 CSS 폭이 ~375px 라 이 구간에 들어오고,
//    데스크톱(수동 '모바일 전환' ~911px 포함)은 들어오지 않는다(mmModalCss.js:4-6 과 같은 근거).
// 🔴 style id 를 모달 CSS(gw-mm-modal-css)와 분리한다 — 기존 모달 계약을 건드리지 않으려고.
// 🔴 display:none·visibility:hidden·overflow:hidden·position 변경 금지(버튼 소실·드롭다운 잘림).
//    저장/취소의 동작(핸들러·폼 제출)은 손대지 않는다 — 순수 표시 스타일이다.
// 🔴 원인은 단정하지 않는다(DEV 실측 전) → 세로 렌더로 가는 경로를 모두 막는다. 유력한 경로:
//    한글은 글자 사이에서 줄바꿈되므로 white-space:normal 인 버튼의 min-content 폭이 '한 글자'다
//    → flex 행에서 짜부수어지면 '저/장' 처럼 쌓인다. ②가 nowrap+keep-all 로 min-content 를 전체
//    텍스트로 올리고 flex-shrink 를 0 으로 둔다(세로쓰기 경로도 같은 규칙이 덮는다). 판정은 D1.
// 🔴 ①은 설계 초안의 flex-wrap:nowrap 을 wrap 으로 바꿨다 — ②로 더 못 줄어드는 버튼이 행에 안
//    들어갈 때 nowrap 은 컨테이너 밖으로 삐져나와 D1 의 '넘침 0' 을 깨뜨린다. wrap 은 글자를
//    쪼개지 않고 버튼 단위로 줄을 내려 둘 다 만족한다(자리가 충분하면 동작은 같다).
export const MM_POST_EDIT_STYLE_ID = 'gw-mm-postedit-css';

export const MM_POST_EDIT_CSS = [
  '@media (max-width:768px){',
  // ① 버튼이 놓인 행 — 자리가 부족하면 글자를 쪼개지 말고 버튼 단위로 줄을 내린다.
  '.post-edit__container [class*="actions" i],.post-edit__container [class*="buttons" i],.post-edit__container [class*="footer" i]{flex-wrap:wrap !important;min-width:0 !important}',
  // ② 버튼 텍스트는 무조건 가로 한 줄(아이콘 버튼에도 무해한 속성만 — 크기는 건드리지 않는다).
  '.post-edit__container button{white-space:nowrap !important;word-break:keep-all !important;overflow-wrap:normal !important;writing-mode:horizontal-tb !important;text-orientation:mixed !important;flex:0 0 auto !important}',
  // ③ 텍스트 버튼(저장·취소)만 폰트·높이를 줄인다(터치 타깃 30px 유지). :has() 로 아이콘 버튼을
  //    제외 → 미지원 브라우저는 이 규칙만 조용히 무시하고 ②는 그대로 유효하다(그래서 분리했다).
  '.post-edit__container button:not(:has(svg)):not(:has(i)):not(:has([class*="icon" i])){width:auto !important;min-width:0 !important;max-width:none !important;font-size:12px !important;line-height:1.35 !important;height:auto !important;min-height:30px !important;padding-top:6px !important;padding-bottom:6px !important;padding-left:10px !important;padding-right:10px !important}',
  '}',
].join('');

// style#gw-mm-postedit-css 를 head 에 '1개만' 유지한다. 폴링 루프(50ms×120)+onLoad 가 반복
// 호출하므로 멱등이 필수 — 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다.
// doc·head 가 없으면(로드 중 문서) 조용히 no-op — applyMmModalCss 와 같은 형태.
export function applyMmPostEditCss(doc) {
  if (!doc || !doc.head) return;
  const found = doc.getElementById(MM_POST_EDIT_STYLE_ID);
  if (found) {
    if (found.textContent !== MM_POST_EDIT_CSS) found.textContent = MM_POST_EDIT_CSS;
    return;
  }
  const st = doc.createElement('style');
  st.id = MM_POST_EDIT_STYLE_ID;
  st.textContent = MM_POST_EDIT_CSS;
  doc.head.appendChild(st);
}
